/** Minimal blocks for `/blog/journal-layout-stub` — layout + bio regression only. */
export const JOURNAL_LAYOUT_STUB_BLOCKS = [
  {
    type: 'p',
    segments: [
      {
        text:
          'This is a stub journal entry. It exists to verify that future posts inherit the same pull-image and author-bio machinery as the founder story — add a slug in postsMeta.js, blocks here, and a route + page wrapper.',
      },
    ],
  },
  { type: 'sig', text: '\u2014 Vanessa' },
];
